<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate" defaultHref="/mitarbeitende/akquise/liste"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'AKQUISEOBJEKT' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (prospect(); as prospect) {
    @let statusBadge = prospect.status | prospectStatusBadge;
    @let contactName = prospect | getFullnameOfContact;
    <div class="padding-16 flex flex-column gap-16">
      <work-ui-badge [text]="statusBadge.text" [variant]="statusBadge.variant" size="small" />

      <div class="work-card flex flex-row space-between gap-12">
        <div class="flex flex-column gap-4">
          <h1>{{ prospect.objectStreet || ('OHNE_STRASSE' | translate) }}</h1>
          <p>{{ prospect.objectZip }} {{ prospect.objectCity }}</p>
          @if (prospect.title) {
            <p><small class="work-text-color-light">{{ prospect.title }}</small></p>
          }
        </div>
        <div class="flex flex-column gap-8">
          <work-ui-button (buttonClick)="openMaps()" [iconOnly]="true" iconName="map" variant="secondary" />
          @if (canUpdate()) {
            <work-ui-button [iconOnly]="true"
                            [routerLink]="['/mitarbeitende/akquise/details', prospect.id, 'bearbeiten']"
                            iconName="edit"
                            routerDirection="forward"
                            variant="secondary" />
          }
        </div>
      </div>

      @if (prospect.status === 'converted') {
        <div class="work-card flex flex-column gap-8">
          <h3>{{ 'AKQUISEOBJEKT_UMGEWANDELT' | translate }}</h3>
          @if (prospect.convertedProject; as convertedProject) {
            <work-ui-button [fullWidth]="true"
                            [queryParams]="{ ignoreErstinstruktion: true }"
                            [routerLink]="['/mitarbeitende/projekte/details', convertedProject.id]"
                            [text]="convertedProject.numberQualified ?? ''"
                            iconName="folder_open"
                            routerDirection="forward"
                            variant="secondary" />
          }
        </div>
      } @else if (prospect.status === 'open') {
        <p><small class="work-text-color-light">{{ 'AKQUISE_UMWANDELN_IM_OFFICE_HINWEIS' | translate }}</small></p>
      }

      @if (hasContactPerson()) {
        <div class="work-card flex flex-column gap-4">
          <h2>{{ 'ANSPRECHPERSON' | translate }}</h2>
          @if (contactName) {
            <p><strong>{{ contactName }}</strong></p>
          }
          @if (prospect.phone) {
            <a [href]="prospect.phone | telHref">{{ prospect.phone }}</a>
          }
          @if (prospect.email) {
            <a [href]="'mailto:' + prospect.email">{{ prospect.email }}</a>
          }
        </div>
      }

      <div class="work-card flex flex-column gap-12">
        <h2>{{ 'NOTIZEN' | translate }}</h2>
        @if (canAddNote()) {
          <form (ngSubmit)="saveNote()" [formGroup]="noteFormGroup" class="flex flex-column gap-8">
            <work-ui-input-field [rows]="2"
                                 [setAutoHeight]="true"
                                 formControlName="notes"
                                 placeholder="AKQUISE_NOTIZ_PLACEHOLDER"
                                 variant="textarea" />
            @if (noteFormGroup.dirty) {
              <work-ui-button [disabled]="noteFormGroup.invalid"
                              [fullWidth]="true"
                              [loadingState]="noteSaveLoadingState()"
                              iconName="check"
                              text="SPEICHERN"
                              type="submit" />
            }
          </form>
        }
        <work-ui-timeline #timeline
                          [interactionsRelationTypeId]="prospect.id"
                          [interactionsRelationType]="WorkInteractionRelationTypeEnum.Prospects" />
      </div>

      <div class="work-card flex flex-column gap-12">
        <h2>{{ 'FOTOS_UND_VIDEOS' | translate }}</h2>
        <work-ui-gallery (documentAnnotated)="loadDocuments()"
                         (documentDeleted)="loadDocuments()"
                         (newDocumentsUploaded)="loadDocuments()"
                         [annotationEnabled]="true"
                         [documentTypeIdentifierName]="WorkDocumenttypeIdentifierNameEnum.Projektfoto"
                         [galleryDocuments]="documents()"
                         [prospectId]="prospect.id"
                         [selectModeEnabled]="false"
                         [uploadEnabled]="isOpen()" />
      </div>
    </div>
  }
</ion-content>
